import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button, Space } from "antd";
import { useNavigate } from "react-router-dom";
import Heading from "./heading";

const Previous = ({ text, prevLink, size }) => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center">
      <Space size={12}>
        <Button
          type="link"
          onClick={() => {
            navigate(prevLink);
          }}
          style={{ padding: 0 }}
        >
          <ArrowLeftOutlined style={{ color: "#000", fontSize: 16 }} />
        </Button>
        <Heading text={text} size={size || 4} style={{ margin: 0 }} />
      </Space>
    </div>
  );
};

export default Previous;
